import { gsap } from "gsap";

// 元素进入动画
export function enterAnimation(element) {
  if (element) {
    gsap.fromTo(
      element,
      { opacity: 0, scale: 0.9 },
      { opacity: 1, scale: 1, duration: 0.5, ease: "power3.out" }
    );
  }
}

// 元素退出动画
export function exitAnimation(element, onComplete) {
  if (element) {
    gsap.to(element, {
      opacity: 0,
      scale: 0.9,
      duration: 0.4,
      ease: "power3.in",
      onComplete,
    });
  }
}

// 道具卡片悬停动画
export function hoverAnimation(itemRefs) {
  if (itemRefs && Array.isArray(itemRefs)) {
    itemRefs.forEach((item) => {
      item.addEventListener("mouseenter", () => {
        gsap.to(item, { scale: 1.1, duration: 0.2 });
      });
      item.addEventListener("mouseleave", () => {
        gsap.to(item, { scale: 1, duration: 0.2 });
      });
    });
  }
}

// 通知弹出动画
export function fadeInUp(element) {
  if (element) {
    gsap.fromTo(
      element,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 0.5, ease: "power3.out" }
    );
  }
}